define([
    "dojo/_base/declare",
    "csi/reflection",
    "csi/xml",
    "./NewUOMAttributes"
], function(declare,reflection,xml,NewUOMAttributes) {

    return declare(NewUOMAttributes, {

		/**
		 * @override
		 * initialize custom attribute form with business object node
		 */
        onCreatePopup(view) {
            view.setBO(this.widget.getViewNode());
            this.inherited(arguments);
        },

		/**
		 * @override
		 */
        toWriter() {
            var	fd = this.m_formData;
            var	id = fd.getFieldValue(xml.ATTR_NAME);
            var	nodeBO = fd.getSource().getParent();

            return this.toWriterBase(reflection.URL + this.m_typeNode + "/" + nodeBO.$Name + "/" + id);
         }
    });
});